// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconList = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-list'}
      data-name='svg-list'
      data-testid='svg-list'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '2.25rem'}
      height={height ?? '2.25rem'}
      viewBox={viewBox ?? '0 0 36 36'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <rect y='5' width='7.5' height='7.58' />
      <rect y='14.5801' width='7.5' height='7.58' />
      <rect y='24.1602' width='7.5' height='7.58' />
      <rect x='9.5' y='5' width='26.5' height='7.58' />
      <rect x='9.5' y='14.5801' width='26.5' height='7.58' />
      <rect x='9.5' y='24.1602' width='26.5' height='7.58' />
    </svg>
  );
};

export default IconList;
